const CONFIG = {
  application: {
    api: {
      addPaymentInstrument: apiKey =>
        `/wallet-services-web/pi/account/ARMGUID/paymentinstrument?apikey=${apiKey}`,
      campaignEvent: guid => `/marketing/v1/marketing/campaign/${guid}/events`,
      cardMetadataSvc: {
        cardBins: '/cardMetadataSvc/cardBins'
      },
      device: '/consumer-api/v1/device',
      enrollCard: namespace => `/wallet-services-web/${namespace}/v1/cards`,
      eventLogging: '/logging/logEvent',
      intent: '/wallet-services-web/xo/account/ARMGUID/intent',
      logout: '/consumer-api/v2/logout',
      lookup: '/consumer-api/v1/lookupUserName',
      marketing: {
        campaign: '/marketing/v1/marketing/campaign'
      },
      merchant: '/wallet-services-web/merchant',
      merchantConstraints: {
        baseUrl: '/wallet-services-web/merchant/constraints'
      },
      piBrand: '/wallet-services-web/pi/brand',
      purchaseIntent: '/wallet-services-web/xo/intent',
      token: {
        activity: namespace => `/apn/${namespace}/oauth2/token/activity`,
        auth: namespace => `/apn/${namespace}/oauth2/token`,
        authMobile: namespace => `/apn/${namespace}/oauth2/token`,
        generateOTP: '/accountServices/login/otp/generate',
        idLookup: namespace => `/apn/${namespace}/oauth2/token/idproof/promise/idLookup`,
        legacySsiSid: '/apn/vxo-web/oauth2/token/sidtoken',
        probe: namespace => `/apn/${namespace}/oauth2/token/probe`,
        recognize: namespace => `/apn/${namespace}/oauth2/token/idproof/promise/recognize`,
        reissuance: namespace => `/apn/${namespace}/oauth2/token/probe/reissuance`,
        renewal: namespace => `/apn/${namespace}/oauth2/token/renewal`,
        revoke: namespace => `/apn/${namespace}/oauth2/lcm/token/authorized/revocation`,
        spawn: namespace => `/apn/${namespace}/oauth2/token/spawn`,
        ssiSid: namespace => `/apn/${namespace}/oauth2/token/sidtoken`,
        stepup: {
          verifyPwd: namespace => `/apn/${namespace}/oauth2/token/2fa`
        },
        verifyOTP: namespace => `/apn/${namespace}/oauth2/token/authorized/password`
      }
    },
    defaults: {
      apiKey: '67095ROOD97N0CIALZGO11Y4MhCbfvgBwXvG5m6wJb3BUPe0w',
      dfpSessionId: 'allowme' //Per ARM team, they follow a specfic format for dfpSessionId. By default they use allowme as a string to pass thru the validation.
    }
  },
  namespace: 'vxo-web' // default namespace vxo-web and in case of vdcp flow this should be `vdcp-web`
};

export default CONFIG;
